import type { ReactNode } from 'react';
import { useTranslation } from '@topolo-io/ui-kit';
import { bindCrmCopy } from '../lib/crm-copy';

export function CrmCopyBoundary({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  bindCrmCopy(t);
  return <>{children}</>;
}
